export default __webpack_public_path__ + "static/media/power-plug.a3214927.svg";